import React from 'react';
import { render } from 'react-dom';
import $ from 'jquery';
import ComponentCopyToClipboard from './component-copy-to-clipboard';

let MountComponent = {
  append(root){
    if (!root) return;
    const id = root.dataset.id;
    const props = {
      data: {
        Id: id
      },
    };

    const component = render(
      <ComponentCopyToClipboard {...props}  />, root);
    return component;
  },

  init() {
    $('[data-mount-copy-to-clipboard]').each((i, elm) => {
      this.append(elm);
    });
  },
};

export default MountComponent;
